function buildPromptToRouteSystemPrompt(
  currentLocation: string | null,
  routeDefsFormatted: string,
): string {
  const currentLocationSection = currentLocation
    ? `\n## Current location:\n${currentLocation}\n`
    : '';

  return `Your job is to translate a prompt into a route definition, path parameter values, and query parameter values.

## Steps:

1. Identify which route definition best matches the prompt's intent based on the available route definitions given below.
2. Resolve ALL **required** path parameter values and query parameter values.
3. Do your best to resolve **optional** path parameter values and query parameter values as well, but if you can't, that is OK, just don't include them in your response.
4. Identify when more information is needed - ONLY in the following cases:
   4.1. The route is unidentifiable.
   4.2. The route has **required** parameters that are not present in the prompt.
   4.3. The parameter value doesn't match the type and/or optional enum values of the parameter in the route definition.
   4.4. The prompt is ambiguous and can map to multiple routes with similar confidence. Use current location to disambiguate. If ambiguity remains, return success=false and explain what destination options are possible.

**Important:** NEVER request more information just because an optional parameter is missing.
${currentLocationSection}
## Available Routes definitions:

${routeDefsFormatted}`;
}

export default buildPromptToRouteSystemPrompt;
